import React from 'react';

const Hero = ({
  title,
  description,
  buttonText,
  customClass,
  imageSrc,
  squareColor,
  onButtonClick
}) => {
  return (
    <div className={`hero-section ${customClass}`}>
      {/* Left Side Content */}
      <div className="hero-content">
        <h1>{title}</h1>
        <p>{description}</p>
        <button
          className={`hero-button`}
          onClick={onButtonClick}
        >
          {buttonText}
        </button>
      </div>

      {/* Right Side Image */}
      <div className="hero-image-container">
        <div className="image-wrapper">
          <div className={`square ${squareColor}`}></div>
          <img src={imageSrc} alt="Hero Img" className="hero-image" />
        </div>
      </div>
    </div>
  );
};

export default Hero;
